export const ADMIN = {
  navDashboard: "admin-nav-dashboard",
  navCandidates: "admin-nav-candidates",
  navIntakes: "admin-nav-intakes",

  statTotal: "admin-stat-total",
  statSubmitted: "admin-stat-submitted",
  statUnderReview: "admin-stat-under-review",
  statApproved: "admin-stat-approved",
  statRejected: "admin-stat-rejected",
  statDocsPending: "admin-stat-docs-pending",
  statDocsExpiring: "admin-stat-docs-expiring",

  filterStatus: "admin-filter-status",
  filterIntake: "admin-filter-intake",
  filterProject: "admin-filter-project",
  searchInput: "admin-search-input",
  candidateRow: (id) => `admin-candidate-row-${id}`,
  candidateOpen: (id) => `admin-candidate-open-${id}`,
  emptyState: "admin-candidates-empty",

  // Detail
  detailRef: "admin-detail-reference",
  detailStatus: "admin-detail-status",
  detailClient: "admin-detail-client",
  detailProject: "admin-detail-project",
  detailRole: "admin-detail-role",
  statusSelect: "admin-detail-status-select",
  reviewNotes: "admin-detail-review-notes",
  saveStatus: "admin-detail-save-status-btn",
  approveBtn: "admin-detail-approve-btn",
  rejectBtn: "admin-detail-reject-btn",

  docCard: (id) => `admin-doc-card-${id}`,
  docView: (id) => `admin-doc-view-${id}`,
  docVerify: (id) => `admin-doc-verify-${id}`,
  docReject: (id) => `admin-doc-reject-${id}`,
  docStatus: (id) => `admin-doc-status-${id}`,

  // Intakes
  intakeClientName: "admin-intake-client-name",
  intakeSlug: "admin-intake-slug",
  intakeDescription: "admin-intake-description",
  intakeCreate: "admin-intake-create-btn",
  intakeRow: (id) => `admin-intake-row-${id}`,
  intakeCopyLink: (id) => `admin-intake-copy-${id}`,
  intakeToggle: (id) => `admin-intake-toggle-${id}`,
};
